export default "__VITE_ASSET__BbGZaioS__"